import { Document, ObjectId } from '@extrahorizon/javascript-sdk';
import { IsoDateTime } from './strings';

/**
 * Wrapper for fetching BillingRecord documents from Exh
 */
export type BillingRecordDocument = Document<BillingRecordData, BillingRecordDocumentStatus>;
/**
 * *Document* Status for BillingRecord documents
 */
export enum BillingRecordDocumentStatus {
  Pending = 'pending',
  Discarded = 'discarded',
  Open = 'open',
  Closed = 'closed',
  Ready = 'ready',
  Error = 'error',
}

/**
 * *BillingStatus* for the BillingRecord, this is not the *Document* status, see {@link BillingRecordDocumentStatus}
 */
export enum BillingStatus {
  NotBillable = 'notBillable',
  ReadyToBill = 'readyToBill',
  Billed = 'billed',
  ClaimAccepted = 'claimAccepted',
  ClaimDenied = 'claimDenied',
}

/**
 * BillingRecord data format
 */
export interface BillingRecordData {
  icdCode: string;
  billingCodes?: string[];
  period: BillingPeriod;
  prescriptionId: ObjectId;
  billingStatus: BillingStatus;
  patientId: ObjectId;
  groupId: ObjectId;
  physicianId: ObjectId;
  patientConsentDate: IsoDateTime;
  fdaClearanceId: string;
  language: string;
  timezone: string;
  output?: BillingOutput;
  measurementIds: ObjectId[];
}

interface BillingPeriod {
  start: IsoDateTime;
  end: IsoDateTime;
}

interface BillingOutput {
  fileToken: string;
  generatedAt: IsoDateTime;
  taskId: ObjectId;
  errorInfo: string;
}
